import { FC } from "react";
import { portuguesePackageDisplayNames } from "../../config/portuguese-Constant";

interface PPPackageDisplayNameProps {
  packageName: string;
}

const PPPackageDisplayName: FC<PPPackageDisplayNameProps> = (props: PPPackageDisplayNameProps) => {
  const displayName: string = portuguesePackageDisplayNames[props.packageName] || props.packageName;
  return <>{displayName}</>;
};

export default PPPackageDisplayName;
